/* Koh theme — vanilla JS (Shopify OS 2.0 port of static main.js).
 * Cart is fully AJAX: /cart.js + /cart/add.js + /cart/change.js.
 * Public API: window.KohCart — see CONVENTIONS.md. */
(function () {
  'use strict';

  var K = window.Koh || {};
  var routes = K.routes || {};
  var strings = K.strings || {};

  /* ---------- Money formatting (cents → shop money format) ---------- */
  function formatMoney(cents) {
    var value = (typeof cents === 'string' ? cents.replace('.', '') : cents) || 0;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = K.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var formatted;
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      default:
        formatted = formatWithDelimiters(value, 2);
    }
    return format.replace(placeholderRegex, formatted);
  }

  /* ---------- Announcement bar rotator ---------- */
  var announce = document.querySelector('[data-announce-rotator]');
  if (announce) {
    var msgs = announce.querySelectorAll('.announce-msg');
    var msgIdx = 0;
    if (msgs.length > 1) {
      setInterval(function () {
        msgs[msgIdx].classList.remove('is-active');
        msgIdx = (msgIdx + 1) % msgs.length;
        msgs[msgIdx].classList.add('is-active');
      }, 4000);
    }
  }

  /* ---------- Sticky header shadow ---------- */
  var header = document.getElementById('header');
  function onScroll() {
    if (header) header.classList.toggle('is-stuck', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Drawers (mobile nav + cart) ---------- */
  var scrim = document.getElementById('drawer-scrim');
  var mobileDrawer = document.getElementById('mobile-drawer');
  var cartDrawer = document.getElementById('cart-drawer');

  function openDrawer(d) {
    if (!d) return;
    d.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    if (mobileDrawer) mobileDrawer.classList.remove('is-open');
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  var hamburger = document.getElementById('hamburger');
  if (hamburger) hamburger.addEventListener('click', function () { openDrawer(mobileDrawer); });
  var cartOpenBtn = document.getElementById('cart-open');
  if (cartOpenBtn) cartOpenBtn.addEventListener('click', function () { openDrawer(cartDrawer); });
  var drawerClose = document.getElementById('drawer-close');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawers);
  var cartClose = document.getElementById('cart-close');
  if (cartClose) cartClose.addEventListener('click', closeDrawers);
  var cartShop = document.getElementById('cart-shop');
  if (cartShop) cartShop.addEventListener('click', closeDrawers);
  if (scrim) scrim.addEventListener('click', closeDrawers);

  /* ---------- Header panels: mega menu + search overlay ---------- */
  var searchPanel = document.getElementById('search-panel');
  var searchToggle = document.getElementById('search-toggle');
  var searchClose = document.getElementById('search-close');
  var searchInput = document.getElementById('search-input');
  var megaToggles = document.querySelectorAll('[data-mega-toggle]');
  var pinnedPanel = null;

  function positionSearchPanel() {
    if (searchPanel && header) {
      searchPanel.style.top = header.getBoundingClientRect().bottom + 'px';
    }
  }
  function openPanel(p) {
    closePanels();
    if (p === searchPanel) positionSearchPanel();
    p.classList.add('is-open');
  }
  function closePanels() {
    document.querySelectorAll('.header-panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
  }
  function panelFor(toggle) {
    return document.getElementById(toggle.getAttribute('data-panel'));
  }

  megaToggles.forEach(function (toggle) {
    var panel = panelFor(toggle);
    if (!panel) return;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-open') && pinnedPanel === panel) {
        pinnedPanel = null;
        closePanels();
      } else {
        pinnedPanel = panel;
        openPanel(panel);
      }
    });
    toggle.addEventListener('mouseenter', function () { openPanel(panel); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) { pinnedPanel = null; closePanels(); }
    });
  });
  if (header) {
    header.addEventListener('mouseleave', function () { if (!pinnedPanel) closePanels(); });
  }
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var willOpen = !searchPanel.classList.contains('is-open');
      if (willOpen) { openPanel(searchPanel); } else { closePanels(); }
      if (willOpen && searchInput) setTimeout(function () { searchInput.focus(); }, 120);
    });
    if (searchClose) searchClose.addEventListener('click', closePanels);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header') && !e.target.closest('.search-panel')) {
      pinnedPanel = null;
      closePanels();
    }
  });
  window.addEventListener('resize', function () {
    if (searchPanel && searchPanel.classList.contains('is-open')) positionSearchPanel();
  });

  /* ---------- Predictive search (/search/suggest.json) ---------- */
  var searchResults = document.getElementById('search-results');
  var searchDefault = document.getElementById('search-default');
  var searchTimer = null;

  function suggestionHtml(p) {
    var art = p.image
      ? '<img src="' + p.image + '" alt="" width="56" height="56" loading="lazy">'
      : '';
    var price = '';
    if (p.price) {
      var cents = Math.round(parseFloat(p.price) * 100);
      if (!isNaN(cents)) price = formatMoney(cents);
    }
    return (
      '<a class="search-result" href="' + p.url + '">' +
        '<span class="search-result-art">' + art + '</span>' +
        '<span class="search-result-title">' + p.title + '</span>' +
        '<span class="search-result-price">' + price + '</span>' +
      '</a>'
    );
  }

  function runPredictiveSearch(q) {
    if (!searchResults) return;
    if (!q) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
      if (searchDefault) searchDefault.hidden = false;
      return;
    }
    var url = (routes.predictiveSearch || '/search/suggest.json') +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var html;
        if (products.length) {
          html = products.map(suggestionHtml).join('') +
            '<a class="search-view-all" href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '">' +
            (strings.searchViewAll || 'View all results') + '</a>';
        } else {
          html = '<p class="search-none">' + (strings.searchNoResults || 'No results found') + '</p>';
        }
        searchResults.innerHTML = html;
        searchResults.hidden = false;
        if (searchDefault) searchDefault.hidden = true;
      })
      .catch(function () { /* keep default pills on error */ });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      searchTimer = setTimeout(function () { runPredictiveSearch(q); }, 250);
    });
  }

  /* ---------- Localization (currency) selectors ---------- */
  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });

  /* ---------- Testimonial carousel (generic) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var dotsWrap = carousel.querySelector('[data-carousel-dots]');
    if (!track || !track.children.length) return;
    var section = carousel.closest('.testimonials') || carousel.parentElement;
    var prev = section ? section.querySelector('[data-testi-prev]') : null;
    var next = section ? section.querySelector('[data-testi-next]') : null;
    var slide = 0;

    function perView() { return window.innerWidth <= 1024 ? 1 : 2; }
    function maxSlide() { return Math.max(0, track.children.length - perView()); }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i <= maxSlide(); i++) {
        (function (i) {
          var b = document.createElement('button');
          b.setAttribute('aria-label', 'Go to review set ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(b);
        })(i);
      }
    }
    function goTo(i) {
      slide = Math.max(0, Math.min(i, maxSlide()));
      var cardW = track.children[0] ? track.children[0].offsetWidth : 0;
      track.style.transform = 'translateX(-' + (slide * (cardW + 22)) + 'px)';
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === slide);
      }
    }
    buildDots(); goTo(0);
    if (prev) prev.addEventListener('click', function () { goTo(slide <= 0 ? maxSlide() : slide - 1); });
    if (next) next.addEventListener('click', function () { goTo(slide >= maxSlide() ? 0 : slide + 1); });
    window.addEventListener('resize', function () { buildDots(); goTo(slide); });
  });

  /* ---------- AJAX cart ---------- */
  function cartJson(options) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(options)
    };
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function cartPlaceholder() {
    var tpl = document.getElementById('cart-line-placeholder');
    return tpl ? tpl.innerHTML : '';
  }

  function renderCartBadge(cart) {
    var badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.hidden = cart.item_count === 0;
  }

  function cartLineHtml(item) {
    var art = item.image
      ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=152" alt="" width="76" height="76" loading="lazy">'
      : cartPlaceholder();
    return (
      '<div class="cart-line" data-key="' + item.key + '">' +
        '<div class="cart-line-art">' + art + '</div>' +
        '<div>' +
          '<p class="cart-line-title">' + item.product_title + '</p>' +
          (item.variant_title ? '<p class="cart-line-price" style="color:var(--text-gray);font-weight:500">' + item.variant_title + '</p>' : '') +
          '<p class="cart-line-price">' + formatMoney(item.final_price) + '</p>' +
          '<span class="cart-qty">' +
            '<button type="button" data-cart-dec="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cart-inc="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</span>' +
        '</div>' +
        '<div>' +
          '<p class="cart-line-total">' + formatMoney(item.final_line_price) + '</p>' +
          '<button type="button" class="cart-line-remove" data-cart-remove="' + item.key + '">' + (strings.remove || 'Remove') + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCart(cart) {
    renderCartBadge(cart);
    var empty = document.getElementById('cart-empty');
    var full = document.getElementById('cart-full');
    var lines = document.getElementById('cart-lines');
    var sub = document.getElementById('cart-subtotal');
    if (empty && full) {
      empty.style.display = cart.item_count ? 'none' : '';
      full.hidden = !cart.item_count;
      if (lines) lines.innerHTML = cart.items.map(cartLineHtml).join('');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
    /* let page scripts (e.g. main-cart) re-render */
    document.dispatchEvent(new CustomEvent('koh:cart', { detail: cart }));
  }

  function refreshCart() {
    return getCart().then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(variantId, quantity) {
    return fetch(routes.cartAdd || '/cart/add.js', cartJson({
      items: [{ id: Number(variantId), quantity: quantity || 1 }]
    }))
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        if (K.cartDrawerEnabled !== false) openDrawer(cartDrawer);
      });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange || '/cart/change.js', cartJson({ id: key, quantity: quantity }))
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* Delegated add-to-cart / qty controls.
   * Add:      <button data-add-to-cart data-variant-id="123" [data-qty="2"]>
   * Qty:      data-cart-inc / data-cart-dec / data-cart-remove = line item key */
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-add-to-cart]');
    if (atc) {
      e.preventDefault();
      var variantId = atc.getAttribute('data-variant-id');
      if (!variantId) return;
      atc.disabled = true;
      addToCart(variantId, parseInt(atc.getAttribute('data-qty'), 10) || 1)
        .catch(function () { window.location.href = routes.cart || '/cart'; })
        .finally(function () { atc.disabled = false; });
      return;
    }
    var dec = e.target.closest('[data-cart-dec]');
    var inc = e.target.closest('[data-cart-inc]');
    var rem = e.target.closest('[data-cart-remove]');
    if (dec || inc || rem) {
      e.preventDefault();
      var key = (dec || inc || rem).getAttribute(dec ? 'data-cart-dec' : inc ? 'data-cart-inc' : 'data-cart-remove');
      getCart().then(function (cart) {
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) {
            var qty = cart.items[i].quantity;
            if (dec) qty -= 1;
            else if (inc) qty += 1;
            else qty = 0;
            changeLine(key, Math.max(0, qty));
            break;
          }
        }
      });
    }
  });

  window.KohCart = {
    get: getCart,
    add: addToCart,
    change: changeLine,
    refresh: refreshCart,
    render: renderCart,
    openDrawer: function () { openDrawer(cartDrawer); },
    closeDrawers: closeDrawers,
    money: formatMoney
  };
  refreshCart();

/* ---------- Escape key ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      pinnedPanel = null;
      closePanels();
    }
  });
})();

/* ============ PAGES (Stage B) ============
 * Port of static js/pages.js, rewired for Shopify:
 * real filters/sort via URL params, real variant data, cart page syncs
 * with window.KohCart via the koh:cart event. Everything here is scoped
 * to elements that only exist on Stage B templates. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    return window.KohCart ? window.KohCart.money(cents) : '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Accordions (PDP, FAQ, help centre) ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (!head) return;
    var item = head.closest('.acc-item');
    if (!item) return;
    var body = $('.acc-body', item);
    var open = item.classList.toggle('is-open');
    if (body) body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Collection: sort select (navigates, keeps filters) ---------- */
  $all('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sel.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  });

  /* ---------- Collection: filter drawer ---------- */
  var filterOpen = $('#filter-open');
  var filterDrawer = $('#filter-drawer');
  var filterClose = $('#filter-close');
  var scrim = $('#drawer-scrim');
  function closeFilter() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (filterOpen && filterDrawer) {
    filterOpen.addEventListener('click', function () {
      filterDrawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    if (filterClose) filterClose.addEventListener('click', closeFilter);
    if (scrim) scrim.addEventListener('click', closeFilter);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilter(); });
  }

  /* ---------- PDP: media gallery (thumb → pane) ---------- */
  var pdpMain = $('#pdp-main');
  var pdpThumbs = $all('.pdp-thumb');
  if (pdpMain && pdpThumbs.length) {
    pdpThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-media-index');
        pdpThumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        $all('.pdp-pane', pdpMain).forEach(function (pane) {
          pane.classList.toggle('is-active', pane.getAttribute('data-pane') === idx);
        });
      });
    });
  }

  /* ---------- PDP: variant picker + price/ATC sync ---------- */
  var variantsEl = $('[data-variants-json]');
  var picker = $('[data-variant-picker]');
  var atcBtn = $('[data-atc-button]');
  if (variantsEl) {
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) {}
    var priceEl = $('[data-pdp-price]');
    var compareEl = $('[data-pdp-compare]');
    var saveEl = $('[data-pdp-save]');
    var badgeSave = $('[data-badge-save]');
    var atcLabel = atcBtn ? $('[data-atc-label]', atcBtn) : null;

    function selectedOptions() {
      return $all('input[type="radio"]:checked', picker)
        .sort(function (a, b) {
          return (parseInt(a.getAttribute('data-option-position'), 10) || 0) -
                 (parseInt(b.getAttribute('data-option-position'), 10) || 0);
        })
        .map(function (input) { return input.value; });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }
    function syncVariant() {
      var v = findVariant(selectedOptions());
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', v.id);
        atcBtn.disabled = !v.available;
      }
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = money(v.compare_at_price);
      }
      if (saveEl) {
        saveEl.hidden = !hasCompare;
        if (hasCompare) saveEl.innerHTML = '&#9432; SAVE ' + money(v.compare_at_price - v.price);
      }
      if (badgeSave) {
        badgeSave.hidden = !hasCompare;
        if (hasCompare) {
          var pct = badgeSave.querySelector('[data-save-pct]');
          if (pct) pct.textContent = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
        }
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    if (picker) picker.addEventListener('change', syncVariant);
  }

  /* ---------- PDP: quantity selector (syncs ATC data-qty) ---------- */
  var qtyInput = $('[data-qty-input]');
  if (qtyInput) {
    var qtyDec = $('[data-qty-dec]');
    var qtyInc = $('[data-qty-inc]');
    var syncQty = function () {
      var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = q;
      if (atcBtn) atcBtn.setAttribute('data-qty', q);
    };
    if (qtyDec) qtyDec.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; syncQty(); });
    if (qtyInc) qtyInc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; syncQty(); });
    qtyInput.addEventListener('change', syncQty);
  }

  /* ---------- Before & After drag sliders ---------- */
  $all('.ba-slider').forEach(function (slider) {
    function setFromEvent(e) {
      var r = slider.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      var pct = Math.max(2, Math.min(98, (x / r.width) * 100));
      slider.style.setProperty('--ba', pct + '%');
    }
    var dragging = false;
    slider.addEventListener('mousedown', function (e) { dragging = true; setFromEvent(e); });
    window.addEventListener('mousemove', function (e) { if (dragging) setFromEvent(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    slider.addEventListener('touchstart', setFromEvent, { passive: true });
    slider.addEventListener('touchmove', setFromEvent, { passive: true });
  });

  /* ---------- Generic filter pills (reviews grid, BA grid, locator) ---------- */
  $all('[data-pill-group]').forEach(function (group) {
    var targetSel = group.getAttribute('data-pill-target');
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.pill-btn');
      if (!btn) return;
      $all('.pill-btn', group).forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (!targetSel) return;
      var f = btn.getAttribute('data-filter');
      $all(targetSel + ' [data-cat]').forEach(function (card) {
        card.style.display = (f === 'all' || card.getAttribute('data-cat') === f) ? '' : 'none';
      });
    });
  });

  /* ---------- Help centre search (scrolls to FAQ) ---------- */
  var helpForm = $('#help-search-form');
  if (helpForm) {
    helpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = $('#help-search-input');
      var faq = $('#help-faq');
      if (q && faq && q.value.trim()) {
        faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ---------- Track order: placeholder status timeline ---------- */
  var trackForm = $('#track-form');
  if (trackForm) {
    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var res = $('#track-result');
      var num = $('#track-number');
      var out = $('#track-order-num');
      if (num && out) out.textContent = num.value || 'KOH-000000';
      if (res) {
        res.classList.add('is-visible');
        res.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* ---------- Store locator: search + state pills ---------- */
  var locSearch = $('#locator-search');
  var locPills = $('#locator-pills');
  function filterStockists() {
    var q = ((locSearch && locSearch.value) || '').toLowerCase();
    var activeState = 'all';
    if (locPills) {
      var b = locPills.querySelector('.pill-btn.is-active');
      if (b) activeState = b.getAttribute('data-filter');
    }
    $all('.stockist-card').forEach(function (card) {
      var text = card.textContent.toLowerCase();
      var okQ = !q || text.indexOf(q) !== -1;
      var okS = activeState === 'all' || card.getAttribute('data-cat') === activeState;
      card.style.display = (okQ && okS) ? '' : 'none';
    });
  }
  if (locSearch) locSearch.addEventListener('input', filterStockists);
  if (locPills) locPills.addEventListener('click', function () { setTimeout(filterStockists, 0); });

  /* ---------- Customer login: password recover toggle ---------- */
  var loginPane = $('[data-login-pane]');
  var recoverPane = $('[data-recover-pane]');
  if (loginPane && recoverPane) {
    var showRecover = function (show) {
      loginPane.hidden = show;
      recoverPane.hidden = !show;
    };
    $all('[data-recover-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var toRecover = link.getAttribute('href') === '#recover';
        showRecover(toRecover);
        try { window.history.replaceState({}, '', toRecover ? '#recover' : '#login'); } catch (err) {}
      });
    });
    if (window.location.hash === '#recover' || recoverPane.querySelector('.form-success.is-visible')) {
      showRecover(true);
    }
  }

  /* ---------- Product recommendations (async section fetch) ---------- */
  $all('[data-product-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.innerHTML.trim()) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* leave section empty on error */ });
  });

  /* ---------- Cart page: sync with koh:cart ---------- */
  var cartPage = $('[data-cart-page]');
  if (cartPage) {
    document.addEventListener('koh:cart', function (e) {
      var cart = e.detail;
      if (!cart) return;
      var lines = $all('[data-cart-line]', cartPage);
      var keys = {};
      cart.items.forEach(function (item) { keys[item.key] = item; });
      /* structural change (added/removed line) → re-render server-side */
      var mismatch = lines.length !== cart.items.length;
      if (!mismatch) {
        for (var i = 0; i < lines.length; i++) {
          if (!keys[lines[i].getAttribute('data-cart-line')]) { mismatch = true; break; }
        }
      }
      if (mismatch) { window.location.reload(); return; }
      lines.forEach(function (line) {
        var item = keys[line.getAttribute('data-cart-line')];
        var qtyEl = line.querySelector('[data-line-qty]');
        var totEl = line.querySelector('[data-line-total]');
        if (qtyEl) qtyEl.textContent = item.quantity;
        if (totEl) totEl.textContent = money(item.final_line_price);
      });
      $all('[data-cart-subtotal]', cartPage).forEach(function (el) {
        el.textContent = money(cart.total_price);
      });
    });
  }
})();
